import { ApiService }   from '../../app-lite/api/api.service';
import { CodeTypeModel }   from '../../app-lite/core/models/code-type';
import { RemoveComponent } from '../../app-lite/table/cell-components/actions/remove.component';
import { Table }           from '../../app-lite/table/types/table';

import NewCountryTypeHtml from './countries.new-country-type.html';
import NewStateTypeHtml   from './countries.new-state-type.html';

interface CountriesStatesScope extends ng.IScope {
  country            : CodeTypeModel;
  countries          : Array<CodeTypeModel>;
  getStatesForCountry: ( countryCode : string ) => void;
  newCountry         : () => void;
  newStateType       : () => void;
  removeItem         : ( row : any ) => void;
  save               : ( form : ng.IFormController ) => void;
  states             : Array<CodeTypeModel>;
  tableSettings      : Table;
}


export function CountriesStatesCtrl (
  $q         : ng.IQService,
  $state     : ng.ui.IStateService,
  $scope     : CountriesStatesScope,
  $translate : ng.translate.ITranslateService,
  $uibModal  : ng.ui.bootstrap.IModalService,
  countries  : Array<CodeTypeModel>,
  messages   : any,
  workshopAPI: ApiService
){

  $scope.country   = null;
  $scope.countries = countries;
  $scope.states    = [];

  $scope.tableSettings = {
    columns: [
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: event => $scope.removeItem(event)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false,
      },
			{
        classes: 'text-left',
        field  : 'code',
        header : {
          text: $translate.instant('COMPANY_SPACE.SETTINGS.CODE')
        }
      },
			{
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: $translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.NO_STATES_FOR_COUNTRY')
    },
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getStatesForCountry = function ( countryCode : string ) {
    workshopAPI.get('/system/states_for_country', countryCode)
    .then(( states : Array<CodeTypeModel> ) => {
      $scope.states = states;
    });
  };

  $scope.newStateType = function () {
    $uibModal.open({
      templateUrl: NewStateTypeHtml,
      controller : 'newStateTypeCtrl',
      resolve    : {
        country_code: () => $scope.country.code
      }
    }).result
    .then(() => {
      $scope.getStatesForCountry($scope.country.code);
    });
  };

  $scope.newCountry = function () {
    $uibModal.open({
      controller : 'newCountryTypeCtrl',
      templateUrl: NewCountryTypeHtml,
      windowClass: 'md-modal'
    }).result
    .then(( country : CodeTypeModel ) => {
      $scope.country = country;

      return workshopAPI.get('/system/country_types');
    })
    .then(( countries : Array<CodeTypeModel> ) => {
      $scope.countries = countries;
    });
  };

  $scope.removeItem = function ( state : any ) {
    workshopAPI.get('/state_types/can_destroy', [ $scope.country.code, state.code ])
    .then(( deletable :string ) => {
      if (deletable === 'true') {
        return workshopAPI.post('/state_type/delete_state', {
          code        : state.code,
          country_code: state.country_code
        }, 'state_type');
      }

      return $q.reject($translate.instant('JS_SPACE.MESSAGES.COMPANIES_USING_GROUP_CANNOT_DELETE'));
    })
    .then(() => {
      $scope.getStatesForCountry($scope.country.code);

      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.STATE'), 'success');
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  $scope.save = function ( form : ng.IFormController ) {
    workshopAPI.patch('/country_type', $scope.country, 'country_type')
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.COUNTRY'), 'success');

      $state.reload();
    })
    .catch(( err : any ) => {
      messages.error(err, form);
    });
  };

}